module.exports = __webpack_public_path__ + "img/symbol_10_x500.7467344c.png";